import axios from "axios";
import { BASE_URL } from '../Utils/base_url';

const AfficheAvisResto = async (idResto, page) => {
    return await axios.get(`${BASE_URL}/avisResto/${idResto}/${page}`);
}

const AfficheRestaurant = async (idResto) => {
    return await axios.get(`${BASE_URL}/afficheRestaurant/${idResto}`);
}


const AjouteFavorie = async (data) => {
    return await axios.post(`${BASE_URL}/ajouteFavoris`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('tokenClient'),
      }
    });
  }

export { AfficheAvisResto, AfficheRestaurant,AjouteFavorie}